export class MillenniumMonth {
    static JANUARY = new MillenniumMonth(0, "jan");
    static FEBRUARY = new MillenniumMonth(1, "feb");
    static MARCH = new MillenniumMonth(2, "mar");
    static APRIL = new MillenniumMonth(3, "apr");
    static MAY = new MillenniumMonth(4, "may");
    static JUNE = new MillenniumMonth(5, "jun");
    static JULY = new MillenniumMonth(6, "jul");
    static AUGUST = new MillenniumMonth(7, "aug");
    static SEPTEMBER = new MillenniumMonth(8, "sep");
    static OCTOBER = new MillenniumMonth(9, "oct");
    static NOVEMBER = new MillenniumMonth(10, "nov");
    static DECEMBER = new MillenniumMonth(11, "dec");
    absoluteMonthNumber;
    representation;
    constructor(absoluteMonthNumber, representation) {
        this.absoluteMonthNumber = absoluteMonthNumber;
        this.representation = representation;
    }
    getRepresentation() {
        return this.representation;
    }
    getAbsoluteMonthNumber() {
        return this.absoluteMonthNumber;
    }
    equals(obj) {
        if (this === obj) {
            return true;
        }
        if (obj === null || obj === undefined) {
            return false;
        }
        if (!(obj instanceof MillenniumMonth)) {
            return false;
        }
        return this.absoluteMonthNumber === obj.absoluteMonthNumber;
    }
}
